import { useCallback, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { logoutUser } from "../store/user/user-action";
import { jwtVerify } from "../utils/jwtVerify";

const useTokenGuard = ({ token, dispatch }) => {
  const location = useLocation();

  const checkToken = useCallback(() => {
    if (!token) return;

    try {
      const isValid = jwtVerify(token);
      if (!isValid) {
        // console.warn(" Token invalid — logging out.");
        logoutUser(dispatch);
      }
    } catch {
      logoutUser(dispatch);
    }
  }, [token, dispatch]);

  //  Handle tab/app/browser switching and returning
  useEffect(() => {
    const onFocus = () => {
      // console.log("Window focused or app returned");
      checkToken();
    };

    const onVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        // console.log("Tab is visible again");
        checkToken();
      }
    };

    window.addEventListener("focus", onFocus); // Browser tab focus
    document.addEventListener("visibilitychange", onVisibilityChange); // App switch, browser switch
    window.addEventListener("pageshow", onFocus); // Back/forward or memory restore

    return () => {
      window.removeEventListener("focus", onFocus);
      document.removeEventListener("visibilitychange", onVisibilityChange);
      window.removeEventListener("pageshow", onFocus);
    };
  }, [checkToken]);

  //  Also check on route change
  useEffect(() => {
    // console.log(" Route changed — check token");
    checkToken();
  }, [location.pathname, checkToken]);
};

export default useTokenGuard;
